import campaignsService from '@/services/campaignsService'

const state = {
  advancedSearchCampaignUsers: {
    status: ''
  },
  campaign: {},
  campaignUsers: [],
  campaigns: [],
  templates: [],
  importErrors: [],
  loadingCampaign: false,
  loadingCampaignUsers: false,
  loadingCampaigns: false,
  loadingTemplates: false,
  paginationCampaigns: {},
  paginationCampaignUsers: {},
  paginationImportErrors: {},
  totalCampaigns: 0,
  totalCampaignUsers: 0,
  totalImportErrors: 0,
  search: '',
  selectTemplate: '',
  templateName: '',
  searchCampaignUsers: '',
  sendingCampaign: false
}

const mutations = {
  'SET_CAMPAIGN' (state, campaign) {
    state.campaign = campaign
  },
  SET_CAMPAIGN_USERS (state, campaignUsers) {
    state.campaignUsers = campaignUsers
  },
  'SET_CAMPAIGNS' (state, campaigns) {
    state.campaigns = campaigns
  },
  'SET_TEMPLATES' (state, templates) {
    state.templates = templates
  },
  'SET_TEMPLATE_NAME' (state, name) {
    state.templateName = name
  },
  'SET_SELECT_TEMPLATES' (state, data) {
    state.selectTemplate = data
  },
  'SET_IMPORT_ERRORS' (state, importErrors) {
    state.importErrors = importErrors
  },
  'SET_TOTAL_CAMPAIGNS' (state, totalCampaigns) {
    state.totalCampaigns = totalCampaigns
  },
  'SET_TOTAL_CAMPAIGN_USERS' (state, totalCampaignUsers) {
    state.totalCampaignUsers = totalCampaignUsers
  },
  'SET_TOTAL_IMPORT_ERRORS' (state, totalImportErrors) {
    state.totalImportErrors = totalImportErrors
  },
  'SET_LOADING_CAMPAIGN' (state, status) {
    state.loadingCampaign = status
  },
  'SET_LOADING_CAMPAIGN_USERS' (state, status) {
    state.loadingCampaignUsers = status
  },
  'SET_LOADING_CAMPAIGNS' (state, status) {
    state.loadingCampaigns = status
  },
  'SET_LOADING_TEMPLATES' (state, status) {
    state.loadingTemplates = status
  },
  'SET_PAGINATION_CAMPAIGN_USERS' (state, pagination) {
    state.paginationCampaignUsers = pagination
  },
  'SET_PAGINATION_CAMPAIGNS' (state, pagination) {
    state.paginationCampaigns = pagination
  },
  'SET_PAGINATION_IMPORT_ERRORS' (state, pagination) {
    state.paginationImportErrors = pagination
  },
  'SET_SENDING_CAMPAIGN' (state, status) {
    state.sendingCampaign = status
  },
  'SET_SEARCH_CAMPAIGNS' (state, search) {
    state.search = search
  },
  'SET_SEARCH_CAMPAIGN_USERS' (state, search) {
    state.searchCampaignUsers = search
  },
  'UPDATE_CAMPAIGN' (state, campaign) {
    state.campaign = campaign
  }
}

const actions = {
  async archiveCampaign (vuexContext, { companyId, appId, campaignId, archiveCampaign }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    return campaignsService.archiveCampaign(vuexContext.getters.token, company, app, campaignId, archiveCampaign)
  },
  createCampaign (vuexContext, { companyId, appId, name, type, date, listId, email, sms, push, whatsapp }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      campaignsService.createCampaign(
        vuexContext.getters.token,
        company,
        app, { name, type, date, listId, email, sms, push, whatsapp })
        .then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
    })
  },
  createCampaignUserList (vuexContext, { companyId, appId, campaignId, createFromUser }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      campaignsService.createCampaignUserList(
        vuexContext.getters.token,
        company,
        app,
        campaignId,
        createFromUser)
        .then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
    })
  },
  getCampaign (vuexContext, { companyId, appId, campaignId }) {
    return new Promise((resolve, reject) => {
      vuexContext.commit('SET_LOADING_CAMPAIGN', true)
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      campaignsService.getCampaign(vuexContext.getters.token, company, app, campaignId)
        .then(response => {
          if (response.campaign) {
            vuexContext.commit('SET_CAMPAIGN', response.campaign)
          } else {
            vuexContext.commit('SET_CAMPAIGN', {})
          }
          vuexContext.commit('SET_LOADING_CAMPAIGN', false)
        })
    })
  },
  getCampaignUsersList (vuexContext, { companyId, appId, campaignId }) {
    return new Promise((resolve, reject) => {
      vuexContext.commit('SET_LOADING_CAMPAIGN_USERS', true)
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      campaignsService.getCampaignUsersList(
        vuexContext.getters.token,
        company,
        app,
        campaignId,
        vuexContext.state.paginationCampaignUsers,
        vuexContext.state.searchCampaignUsers,
        vuexContext.state.advancedSearchCampaignUsers)
        .then(response => {
          if (response && response.campaignsUsers) {
            vuexContext.commit('SET_LOADING_CAMPAIGN_USERS', false)
            vuexContext.commit('SET_TOTAL_CAMPAIGN_USERS', response.campaignsUsers.count)
            vuexContext.commit('SET_CAMPAIGN_USERS', response.campaignsUsers.rows)
            vuexContext.commit('SET_LOADING_CAMPAIGN', false)
          }
        })
        .catch(() => {
          vuexContext.commit('SET_LOADING_CAMPAIGN_USERS', false)
          vuexContext.commit('SET_CAMPAIGN_USERS', [])
          vuexContext.commit('SET_TOTAL_CAMPAIGN_USERS', 0)
          vuexContext.commit('SET_LOADING_CAMPAIGN', false)
        })
    })
  },
  getCampaigns (vuexContext, { archivedCampaign }) {
    vuexContext.commit('SET_LOADING_CAMPAIGNS', true)
    campaignsService.getCampaigns(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      vuexContext.state.paginationCampaigns,
      vuexContext.state.search,
      archivedCampaign)
      .then(response => {
        vuexContext.commit('SET_LOADING_CAMPAIGNS', false)
        vuexContext.commit('SET_TOTAL_CAMPAIGNS', response.campaigns.count)
        vuexContext.commit('SET_CAMPAIGNS', response.campaigns.rows)
      })
      .catch(() => {
        vuexContext.commit('SET_LOADING_CAMPAIGNS', false)
        vuexContext.commit('SET_CAMPAIGNS', [])
      })
  },
  getTheErrorsGeneratedByTheUpload (vuexContext, { companyId, appId, campaignId }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      campaignsService.getTheErrorsGeneratedByTheUpload(
        vuexContext.getters.token,
        company,
        app,
        campaignId,
        vuexContext.state.paginationImportErrors
      ).then((response) => {
        vuexContext.commit('SET_TOTAL_IMPORT_ERRORS', response.errorLogs.count)
        vuexContext.commit('SET_IMPORT_ERRORS', response.errorLogs.rows)
        resolve(true)
      })
    })
  },
  sendCampaign (vuexContext, { companyId, appId, campaignId, schedule, scheduleDate }) {
    return new Promise((resolve, reject) => {
      vuexContext.commit('SET_SENDING_CAMPAIGN', true)
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      campaignsService.sendCampaign(vuexContext.getters.token, company, app, campaignId, { schedule, scheduleDate })
        .then(() => {
          vuexContext.commit('SET_SENDING_CAMPAIGN', false)
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  uploadUsersForTheCampaignDirectly (vuexContext, { companyId, appId, campaignId, file }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      campaignsService.uploadUsersForTheCampaignDirectly(vuexContext.getters.token, company, app, campaignId, file)
        .then(() => {
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  saveTemplate (vuexContext, data) {
    return new Promise((resolve, reject) => {
      const companyId = vuexContext.getters.companyUuid
      const appId = vuexContext.getters.appUuid
      const token = vuexContext.getters.token
      campaignsService.saveTemplate(token, companyId, appId, data)
        .then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
    })
  },

  getTemplateById (vuexContext, templateId) {
    return new Promise((resolve, reject) => {
      const companyId = vuexContext.getters.companyUuid
      const appId = vuexContext.getters.appUuid
      const token = vuexContext.getters.token
      campaignsService.getTemplateById(token, companyId, appId, templateId)
        .then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
    })
  },
  getTemplates (vuexContext) {
    return new Promise((resolve, reject) => {
      vuexContext.commit('SET_LOADING_TEMPLATES', true)
      campaignsService.getTemplates(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid
      ).then(response => {
        vuexContext.commit('SET_LOADING_TEMPLATES', false)
        vuexContext.commit('SET_TEMPLATES', response.templates.rows)
        resolve(response)
      }).catch((error) => {
        vuexContext.commit('SET_LOADING_TEMPLATES', false)
        vuexContext.commit('SET_TEMPLATES', [])
        reject(error)
      })
    })
  },
  getTemplatesByName (vuexContext, templateName) {
    return new Promise((resolve, reject) => {
      campaignsService.getTemplatesByName(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        templateName
      ).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  async updateTemplate (vuexContext, data) {
    await campaignsService.updateTemplate(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      data
    )
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
